import { DefaultUrlSerializer, UrlTree } from '@angular/router';

export class UpperCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        const urlTree = url.split('/');
        const urlWithSynappsIdUpper = urlTree.map((tree) => this.isSynappsId(tree) ? tree.toUpperCase() : tree);
        return super.parse(urlWithSynappsIdUpper.join('/'));
    }

    private isSynappsId(value: string) {
        return /^[a-zA-Z]{3}-[0-9a-zA-Z]{6}$/.test(value) || /^BPJ[0-9a-zA-Z]{6}$/.test(value);
    }
}


